// The release name BugSnag reports carry. next.config.js inlines the build's
// commit here (config/app-version.cjs); only an unbundled run sees the default.
module.exports = process.env.KICKOFF_APP_VERSION || 'development'
